import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const QK65 = () => (
  <ArticleWrapper articleId="qk65">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>QK65</h1>
        <img src="/pictures/gallery/gallery1.JPG" alt="QK65" className="rounded-lg mb-6" />
        {/* Add your QK65 article content here */}
      </div>
    </div>
  </ArticleWrapper>
);

export default QK65;
